import { Oval } from 'react-loader-spinner';
import styled, { useTheme } from 'styled-components';

interface IProps {
    size?: number;
}

export const Loader = ({ size }: IProps) => {
    const theme = useTheme();

    return (
        <LoaderWrapper>
            <Oval
                height={size ? size : 100}
                width={size ? size : 100}
                color={theme.colors.primary}
                visible={true}
                ariaLabel="loading-indicator"
                secondaryColor={theme.colors.primary}
                strokeWidth={4}
                strokeWidthSecondary={3}
            />
        </LoaderWrapper>
    );
};

export const LoaderWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
